module.exports = __webpack_public_path__ + "static/media/ag-products9.ef510f84.jpg";